import React from "react";
import "./HeroBanner.css";

const HeroBanner = () => {
  return (
    <section className="hero-banner">
      <div className="hero-content">
        <h1 className="hero-title">
          Your <span>First Job</span> Starts Here <br></br> Let’s Make It Happen!
        </h1>
        <h6 className="hero-subtext_home">
          <b>
            I’m here to guide students and freshers to kickstart their careers —
            from building powerful profiles to connecting with real job
            opportunities. Together, we’ll turn your ambition into action.
          </b>
        </h6>
        <div className="hero-buttons">
          <button className="primary-btn">Get Started</button>
          <button className="secondary-btn">Explore Opportunities</button>
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
